import React from 'react';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import useWindowSize from '@hooks/useWindowSize';
import Paper from '@unicons-base/Paper/Paper';
import Image from '@base/Image';
import Typography from '@unicons-base/Typography/Typography';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';

interface LearningOutcomeCardProps {
  totalCount: number;
  outcomeSrc: string;
  gridColumn: string;
  title: string;
}

type CardWrapperType = {
  $isSingleMWCard: boolean;
};

const CardWrapper = styled(Paper)<CardWrapperType>`
  position: relative;
  padding: 0;
  border-radius: ${Spacings.SPACING_1B};
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 56.71%,
    rgba(0, 0, 0, 0.9) 100%
  );
  width: 244px;
  height: 164px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    height: auto;
    width: auto;
  }
`;

const StyledTypography = styled(Typography)`
  position: absolute;
  z-index: 2;
  margin-top: auto;
  font-size: ${Fonts.H5};
  color: var(--color-i-icon-light-tertiary);
  font-weight: ${Fonts.SEMIBOLD};
  bottom: 16px;
  left: 16px;
  margin-bottom: 0;
  ${mediaQuery.uptoMobile} {
    position: relative;
    color: var(--color-i-icon-dark-secondary);
    font-size: ${Fonts.H6};
    bottom: 0px;
    left: 0px;
    margin-top: 12px;
    margin-bottom: auto;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  padding: ${Spacings.SPACING_4B};
  width: 244px;
  min-width: 244px;
  height: 164px;
  overflow: hidden;
  border-radius: ${Spacings.SPACING_1B};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & img {
    object-fit: cover;
  }
  ${mediaQuery.uptoMobile} {
    width: 150px;
    height: 100px;
    min-width: 150px;
    max-width: 150px;
  }
`;

const LearningOutcomeCard: React.FC<LearningOutcomeCardProps> = ({
  totalCount,
  outcomeSrc,
  gridColumn,
  title
}) => {
  const { isMobile } = useWindowSize();

  return (
    <CardWrapper
      gridColumn={gridColumn}
      $isSingleMWCard={totalCount === 1 && isMobile}
    >
      <ImageWrapper>
        <Image src={outcomeSrc} alt={title} layout="fill" />
      </ImageWrapper>
      <StyledTypography variant={UN_ICONS_TYPOGRAPHY_VARIANT.H3}>
        {title}
      </StyledTypography>
    </CardWrapper>
  );
};

LearningOutcomeCard.displayName = 'LearningOutcomeCard';

export default LearningOutcomeCard;
